export default "__VITE_ASSET__CndGaEqi__"